import { BaseActionEnum } from "../../components/action-menu/ActionMenuItem";
import i18n from "../../services/localization-service/i18n";
import { getActionMenuItems } from "../../components/action-menu/BaseActions";

const actionEnums = [
     BaseActionEnum.Export,
     BaseActionEnum.Refresh,
     BaseActionEnum.Run
];

const actions = getActionMenuItems(actionEnums);
const runAction = actions.find(o => o.action === BaseActionEnum.Run);
if (runAction) {
    runAction.label = i18n.t("actions.runReport");
}

export const auditReportingActionItems = actions;



